export default "__VITE_ASSET__DUvCfqPz__"